<route-container
  [uid]="'session'"
>
  <loader-container
    [loader]="loader"
    [options]="{
    contentTemplate: preview
  }"
    (loaded)="session = $event"
  ></loader-container>
</route-container>

<ng-template #preview>
  <div *ngIf="session">
    <data-preview
      [item]="session"
      [options]="{
        properties: {
        'createdBy': { heading: 'Created by', order: 51, valueRenderTemplate: propertyOwner },
        'id': { heading: 'UID', order: 1 },
        'name': { heading: 'Name', order: 2 },
        'description': { heading: 'Description', order: 3 },
        'messages': { hidden: true },
        'templateId': { heading: 'Template', renderTemplate: propertyTemplate },
        'templateName': { hidden: true },
        'chatbot': { heading: 'Assistant', renderTemplate: propertyChatbot }
        }
      }"
    ></data-preview>
    <actions-container *ngIf="!hideActions" [ngClass]="'pb-4'">
      <back-button></back-button>
      <button [routerLink]="['./chat']" color="primary" mat-raised-button>
        <mat-icon>chat</mat-icon> Chat
      </button>
      <delete-button
        [routerLink]="['../../delete', sessionId!]">
      </delete-button>
    </actions-container>
  </div>
</ng-template>

<ng-template #propertyOwner let-propertyValue=propertyValue>
  <user-id-tag
    [userId]="propertyValue"
  ></user-id-tag>
</ng-template>

<ng-template #propertyTemplate let-objectValue=objectValue>
  <div class="fw-normal">Template</div>
  <div class="fw-light">
    <a class="link-underline-light" target="_blank"
      [routerLink]="['/templates/preview', objectValue['templateId']]">
      {{objectValue['templateName']}}
    </a>
  </div>
</ng-template>


<ng-template #propertyChatbot let-objectValue=objectValue>
  <div class="fw-normal">Assistant</div>
  <div class="fw-light">
    <a class="link-underline-light" target="_blank"
       [routerLink]="['/chatbots', objectValue['chatbot']]">
      {{objectValue['chatbot']}}
    </a>
  </div>
</ng-template>
